module.exports = __webpack_public_path__ + "img/Receita-Federal.f3fb27e.png";